<template>
	<div class='container'>
		<div class='card shadow-sm mb-4 w-100' style="">
			<div id="accordion">
				<div class="card">
				<div class="card-header">
					<a class="card-link text-primary" v-b-toggle.accordion-1>
					Terms and Conditions
					</a>
				</div>
				<b-collapse id="accordion-1" visible accordion="accordion" role="tabpanel" class="py-4 px-4">
					<!-- <div class="card-body"> -->
						The following Terms and Conditions apply to all hire from Ellis Audio in accordance with clause 2<!-- A printable copy of the <a href="/public/Ts&Cs.pdf" target="_blank">Terms & Conditions</a> is available here. -->
					<!-- </div> -->
				</b-collapse>
				</div>
				<div class="card">
				<div class="card-header">
					<a class="card-link text-primary" v-b-toggle.accordion-2>
					1. Definitions
					</a>
				</div>
				<b-collapse id="accordion-2" visible accordion="accordion" role="tabpanel" class="py-4 px-4">
					<!-- <div class="card-body"> -->
						1.1. “Ellis Audio” means Nicholas James Ellis ABN 82 403 813 991 trading as Ellis Audio.<br>
						1.2. “Client” means the person/s hiring Equipment, as specified in any invoice or quote.<br>
						1.3. “Equipment” means all Equipment including any accessories supplied on hire by Ellis Audio to the Client. The Equipment shall be as described on the invoices or quotation provided by Ellis Audio to the Client.<br>
						1.4. “Price” means the amount payable for the Equipment hire as agreed between Ellis Audio and the Client in accordance with clause 4 below.
					<!-- </div> -->
				</b-collapse>
				</div>


				<div class="card">
				<div class="card-header">
					<a class="card-link text-primary" v-b-toggle.accordion-3>
					2. Acceptance of Terms and Conditions
					</a>
				</div>
				<b-collapse id="accordion-3" visible accordion="accordion" role="tabpanel" class="py-4 px-4">
					<!-- <div class="card-body"> -->
					2.1. The Client accepts and is immediately bound to these terms and conditions by requesting a quote and/or requesting a booking with Ellis Audio.
					<!-- </div> -->
				</b-collapse>
				</div>

				<div class="card">
				<div class="card-header">
					<a class="card-link text-primary" v-b-toggle.accordion-4>
						3. Booking
					</a>
				</div>
				<b-collapse id="accordion-4" visible accordion="accordion" role="tabpanel" class="py-4 px-4">
					<!-- <div class="card-body"> -->
						3.1. Booking of Equipment is to be confirmed by the payment of a non refundable $50 prepayment by the Client, except in the case of clause 5.2.
					<!-- </div> -->
				</b-collapse>
				</div>
				<div class="card">
				<div class="card-header">
					<a class="card-link text-primary" v-b-toggle.accordion-5>
					4. Payment
					</a>
				</div>
				<b-collapse id="accordion-5" visible accordion="accordion" role="tabpanel" class="py-4 px-4">
					<!-- <div class="card-body"> -->
						4.1. Payment for a booking is to be made in full on or before the date listed on the invoice, if there is no date listed then the total amount will be payable on or before the day of hire.<br>
						4.2. Ellis Audio reserves the right to change the Price if a variation to Ellis Audio’s quotation is requested. If a variation is requested then a new invoice will be issued by Ellis Audio.<br>
						4.3. At Ellis Audio’s sole discretion a non-refundable deposit may be required.<br>
						4.4. Payment may be made by cash, cheque, electronic/online banking, credit card (plus a surcharge of up to three percent (3%)), or by any other method as agreed to between the Client and Ellis Audio.<br>
						4.5. Unless otherwise stated the Price does not include GST.
					<!-- </div> -->
				</b-collapse>
				</div>

				<div class="card">
				<div class="card-header">
					<a class="card-link text-primary" v-b-toggle.accordion-6>
					5. Cancellations
					</a>
				</div>
				<b-collapse id="accordion-6" visible accordion="accordion" role="tabpanel" class="py-4 px-4">
					<!-- <div class="card-body"> -->
					5.1. Ellis Audio reserves the right to cancel the booking at anytime.<br>
					5.2. If Ellis Audio cancels the booking for any reason other than the breach of these terms and conditions by the Client, the deposit will be refunded.<br>
					5.3. If the Client cancels the booking more that one (1) week prior to the date of hire, the deposit may be refunded at the sole discretion of Ellis Audio.
					<!-- </div> -->
				</b-collapse>
				</div>

				<div class="card">
				<div class="card-header">
					<a class="card-link text-primary" v-b-toggle.accordion-7>
						6. Hire Conditions
					</a>
				</div>
				<b-collapse id="accordion-7" visible accordion="accordion" role="tabpanel" class="py-4 px-4">
					<!-- <div class="card-body"> -->
						6.1. The Equipment will at all times remain the sole property of Ellis Audio and is to be returned upon the demand of Ellis Audio at any time.<br>
						6.2. The Equipment must be returned to Ellis Audio on or before midday (12pm) on the day following the final date of hire, unless otherwise specified by Ellis Audio.<br>
						6.3. At the Sole discretion of Ellis Audio the date of return may be extended by Ellis Audio.<br>
						6.4. In the event that the Equipment is not returned in the same condition or is not returned at all, Ellis Audio retains the right to charge the Client for the cost of repair or replacement of the Equipment, at the sole discretion of Ellis Audio.<br>
						6.5. The Client shall have no claim over the Equipment at any point in time. The Client shall keep the Equipment in their possession for the duration agreed upon only and shall not be
						entitled to any rights of ownership.<br>
						6.6. The Client is responsible for the safe return of the Equipment in the condition that it was delivered. The Client is required to insure or self insure the Equipment against any damage including but not limited to accident, fire, flood, theft and any other usual risk. The Client is also responsible to provide adequate Public Liability insurance to protect again and harm to persons or property arising from the Equipments use.<br>
						6.7. The Equipment must not be used in any way that would void the insurance of the Equipment.<br>
						6.8. The Client must not modify or make any additions to the Equipment, including but not limited to, deface, remove any plates, erase any identifying marks, remove any stickers or interfere with the Equipment in anyway.
					<!-- </div> -->
				</b-collapse>
				</div>
				<div class="card">
				<div class="card-header">
					<a class="card-link text-primary" v-b-toggle.accordion-8>
					7. Pickup and Delivery
					</a>
				</div>
				<b-collapse id="accordion-8" visible accordion="accordion" role="tabpanel" class="py-4 px-4">
					<!-- <div class="card-body"> -->
						7.1. All bookings include pickup from and return to the premises of Ellis Audio by the Client only, unless delivery/pickup and/or setup/packdown by Ellis Audio is arranged and agreed to prior to the day of hire between Ellis Audio and the Client.<br>
						7.2. At the sole discretion of Ellis Audio delivery may be included at an additional cost to the Price. The additional fee will be set by Ellis Audio and agree prior to delivery.<br>
						7.3. Any time or date given by Ellis Audio to the Client is an estimate only. The Client must still accept delivery of the Equipment even if late and Ellis Audio will not be liable for any loss or damage incurred by the Client as a result of the delivery being late.<br>
						7.4. The Client must provide adequate and appropriate space at the site for the delivery and setup of the Equipment.<br>
						7.5. The Client must allow Ellis Audio access for delivery, setup and pack up of the Equipment at all reasonable times upon reasonable notice from Ellis Audio.
					<!-- </div> -->
				</b-collapse>
				</div>

				<div class="card">
				<div class="card-header">
					<a class="card-link text-primary" v-b-toggle.accordion-9>
					8. Risk, damage and Liability
					</a>
				</div>
				<b-collapse id="accordion-9" visible accordion="accordion" role="tabpanel" class="py-4 px-4">
					<!-- <div class="card-body"> -->
					8.1. Once the Equipment has been picked up or delivered, the Client assumes sole responsibility for the Equipment, including but not limited to any risk of liability, and damage to the equipment.<br>
					8.2. The Client agrees to insure or self insure the Equipment against any damage or Liability.
					<!-- </div> -->
				</b-collapse>
				</div>
			</div>
		</div>
		</div> 
</template>



<script>

	export default{
		data(){
			return {
			}
		},
	}
</script>